import {computed, makeObservable} from "mobx";
import SaporeForm from "../forms/SaporeForm";
import FileField from "../forms/fields/FileField";

export default class TaxProfileForm extends SaporeForm {

    static newFor(initialData = {}, feature = null) {
        return new TaxProfileForm(initialData, feature);
    }

    constructor(initialData = {}, feature = null) {
        const form = super({}, null, feature, {mandatoryFields: [], readonlyFields: []});
        const fields = {
            cm01form: new FileField(0, 1, true, initialData.cm01form, feature),
            cm05form: new FileField(0, 1, !feature.hasMultipleJurisdictions, initialData.cm05form, feature),
        };

        form.setFields(fields);

        makeObservable(this, {
            cm01formValue: computed,
            cm05formValue: computed,
        });
    }

    configurationFieldNameMapping() {
        return {
            cm01form: '_cm01_form',
            cm05form: '_cm05_form',
        };
    }

    cm01form() {
        return this.getFieldByName('cm01form').value;
    }

    cm05form() {
        return this.getFieldByName('cm05form').value;
    }

    get cm01formValue() {
        return this.cm01form();
    }

    get cm05formValue() {
        return this.cm05form();
    }
}
